export default "__VITE_ASSET__Blll3Yf8__"